export type Appearance = 'dark' | 'light';
export function appearanceFrom(value: unknown): Appearance { return value === 'light' ? 'light' : 'dark'; }
export const arenaPalette = {
 dark: {background:'#20282c',floor:'#424d50',platform:'#20282c',seat:'#586567',accent:'#a9e0c8',wood:'#c4ba9c'},
 light: {background:'#dce3e2',floor:'#b8c7c4',platform:'#728580',seat:'#93aaa2',accent:'#579881',wood:'#c4ba9c'},
} as const;
